//local
export const apiBaseUrl = process.env.REACT_APP_API_END_POINT;

//accounts
export const getAccountsList = apiBaseUrl + 'Accounts/grid';

export const getAccountInfo = (id: number | null | string): string =>
  apiBaseUrl + 'accounts/' + id;

export const saveAccounts = apiBaseUrl + 'accounts';

// contacts
export const getContactList = (account: number | string): string =>
  `${apiBaseUrl}accounts/${account}/contacts/grid`;

export const contactItem = (accountId: number, contactId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/contacts/${contactId}`;

export const addContact = (account: number): string =>
  `${apiBaseUrl}accounts/${account}/contacts`;

//locations
export const getLocationList = (accountId: number | string): string =>
  `${apiBaseUrl}accounts/${accountId}/locations/grid`;

export const locationItem = (account: number | string, locId: number): string =>
  `${apiBaseUrl}accounts/${account}/locations/${locId}`;

export const saveLocation = (account: number): string =>
  `${apiBaseUrl}accounts/${account}/locations`;

//Questions
export const addQuestionToRepository = `${apiBaseUrl}question-templates`;

export const getQuestionsList = `${apiBaseUrl}question-templates/grid`;

// question detail(GET,UPDATE)
export const questionDetailItem = (questionTemplateId: number): string =>
  `${apiBaseUrl}question-templates/${questionTemplateId}`;

export const getQuestionTypes = `${apiBaseUrl}questions/types`;

export const getTextFormats = `${apiBaseUrl}questions/details/formats`;

export const getQuestionSpecifications = (
  questionTypeName: string | undefined,
): string =>
  `${apiBaseUrl}questions/types/${questionTypeName}/options/specification`;

export const getQuestionSpecificationsForLookup = (
  questionTypeName: string | undefined,
): string =>
  `${apiBaseUrl}questions/types/${questionTypeName}/options/specification?subtype=template`;

export const officeFactsItem = (accountId: number | string): string =>
  `${apiBaseUrl}accounts/${accountId}/office-facts`;

export const tagMappings = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/tag-mappings`;

export const ftpSettings = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/ftpsettings`;

export const updateFingerPrint = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/ftpsettings/fingerprint`;

export const formsList = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/surveys/grid`;

//form details(GET,PUT)
export const formDetails = (accountId: number, formId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/surveys/${formId}`;

export const saveNewForm = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/surveys`;

export const copyForm = (accountId: number, formId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/surveys/${formId}/copy`;

export const copySection = (
  accountId: number | string,
  id: number | string,
): string => `${apiBaseUrl}accounts/${accountId}/surveys/${id}/sections/copy`;

export const copyQuestion = (
  accountId: number,
  surveyId: number,
  sectionId: number,
  questionId: number,
): string =>
  `${apiBaseUrl}accounts/${accountId}/surveys/${surveyId}/sections/${sectionId}/copy-questions/${questionId}`;

export const copyAccount = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/copy`;

// save import account(currently selected account)
export const saveImportAccount = (
  accountId: number,
): string => `${apiBaseUrl}accounts/${accountId}/import
`;

export const getGlobalSurvey = `${apiBaseUrl}global-sections/grid`;

//Master Data
export const getAccountService = apiBaseUrl + 'account-service';
export const getAccountStatus = apiBaseUrl + 'account-status';
export const getTimezone = apiBaseUrl + 'timezone';
export const getStateProvince = apiBaseUrl + 'state-province';
export const getRelationshipManagers = apiBaseUrl + 'relationship-manager';
export const xmlTags = `${apiBaseUrl}xml-tags`;
export const getCallTypes = `${apiBaseUrl}call-types`;

export const getUserPermissions = apiBaseUrl + 'accounts/permissions';

//Procedures
export const createProcedure = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/create`;

export const archiveProcedure = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/archive`;

export const saveProcedure = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/save`;

export const cloneProcedure = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/clone`;

export const getProcedureDetails = (
  accountId: number | undefined,
  procedureId: number | undefined,
): string => `${apiBaseUrl}accounts/${accountId}/procedures/${procedureId}`;

export const publishProcedure = (
  accountId: number,
  makeProceduresVisible?: boolean,
): string =>
  makeProceduresVisible
    ? `${apiBaseUrl}accounts/${accountId}/procedures/publish?makeNewProceduresVisible=${makeProceduresVisible}`
    : `${apiBaseUrl}accounts/${accountId}/procedures/publish`;

export const discardProcedureContent = (
  accountId: number,
  procedureId: number,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/${procedureId}/undo
        `;

export const renameProcedure = (
  accountId: number | undefined,
  procedureId: number | undefined,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/${procedureId}/rename`;

export const forceRenameProcedure = (
  accountId: number | undefined,
  procedureId: number | undefined,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/policymenu/display-name?procedureId=${procedureId}`;

export const getArchivedProcedureList = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/archived`;

// procedure builder - procedures list
export const getProceduresInProcedureBuilder = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures?procedureDisplayMode=2`;

export const versionHistoryList = (
  accountId: number,
  procedureId: number | undefined,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/${procedureId}/versions`;

export const procedureVersionDetail = (
  accountId: number,
  fileId: string,
  snapshotTime: number | undefined,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/${fileId}/version/${snapshotTime}`;

export const restoreVersions = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/restore`;

export const getPublishedProcedureList = (
  accountId: number,
): string => `${apiBaseUrl}accounts/${accountId}/procedures/published
`;

export const convertToGlobalProcedure = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/change-to-global`;

export const convertToNormalProcedure = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/change-to-normal`;

export const getProcedureReference = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/get-references`;

export const getGlobalProcedureList = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/global`;

export const deleteProcedure = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures`;

export const cleanProcedure = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/clean-procedure`;

export const linkedAccountsForGlobalProcedure = (
  accountId: number,
  procedureId: number,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/${procedureId}/global/linked-accounts`;

export const resetPolicyMenu = (
  accountId: number | undefined,
  procedureId: number | undefined,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/${procedureId}/reset`;

export const createPolicyMenu = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/policiesmenu/create`;

//Custom Lookups
//get,post,put
export const customLookupTables = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/lookups`;

export const deleteCustomLookupTables = (
  accountId: number,
  tableId: string,
  removeIfAssociationWithDeletedQuestion?: boolean,
): string =>
  removeIfAssociationWithDeletedQuestion
    ? `${apiBaseUrl}accounts/${accountId}/lookups/${tableId}?removeIfAssociationWithDeletedQuestion=${removeIfAssociationWithDeletedQuestion}`
    : `${apiBaseUrl}accounts/${accountId}/lookups/${tableId}`;

export const getCustomRecords = (accountId: number, lookupId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/lookups/${lookupId}/grid`;

export const getCustomTableWithRecords = (
  accountId: number,
  lookupId: number,
): string =>
  `${apiBaseUrl}accounts/${accountId}/lookups/${lookupId}?includeRecords=true`;

export const addCustomRecords = (accountId: number, lookupId: string): string =>
  `${apiBaseUrl}accounts/${accountId}/lookups/${lookupId}/record`;

//edit,delete
export const editCustomRecords = (
  accountId: number,
  lookupId: string,
  recordId: string,
  RemoveIfAssociationWithDeletedQuestion?: boolean,
): string =>
  RemoveIfAssociationWithDeletedQuestion === true
    ? `${apiBaseUrl}accounts/${accountId}/lookups/${lookupId}/record/${recordId}?RemoveIfAssociationWithDeletedQuestion=${RemoveIfAssociationWithDeletedQuestion}`
    : `${apiBaseUrl}accounts/${accountId}/lookups/${lookupId}/record/${recordId}`;

export const getBrokenLinksForDismissal = (
  accountId: number,
  payloadString: string | undefined,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/broken-links?${payloadString}`;

export const dismissLinks = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/update-links`;

//To duplicate imported procedures (manage visibility and publish)
export const copyImportedProcedures = (
  accountId: number,
  importMode: string,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/force-import/${importMode}`;

//(POST, PUT - Tables, Layout)
export const createUpdateTemplates = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/template`;

//(GET - Tables,layouts)
export const getTemplates = (accountId: number, templateType: string): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/template/${templateType}`;

//For deleting and renaming title of tables and layouts
export const deleteTemplate = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/blob-table-layout`;

export const deleteTemplateGroup = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/blob-folder`;

export const getBlobFiles = (
  accountId: number,
  uniqueId: string | undefined,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/get-blob-files?cidsidpid=${uniqueId}`;

export const uploadFile = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/upload-blob-file`;

export const deleteBlobFile = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/blob-file`;

export const importBlobFiles = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/import-blob-files`;

export const editTemplateName = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/rename-blob-file`;

export const editTemplateGroupName = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/rename-blob-directory`;

export const createBlobDirectory = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/create-blob-directory`;

export const linkProcedures = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/link`;

// version api call in iframe
export const getVersionIframe =
  'https://proteus-api-host-dev.azurewebsites.net/api/version';

//import and publish
export const importProcedure = (
  accountId: number | string,
  ProcedureImportModes: string,
): string =>
  `${apiBaseUrl}accounts/${accountId}/Procedures/import/${ProcedureImportModes}`;

export const getCheckLinks = (
  accountId: string | null,
  surveyId: string | null,
): string => `${apiBaseUrl}accounts/${accountId}/survey/${surveyId}/links`;

//url validation in text questions
export const urlValidation = (url: string): string =>
  `${apiBaseUrl}accounts/validate-link?url=${url}`;

export const getAccountListForLinkingProcedures = (
  accountId: number,
  start: number,
  pageLength: number,
  keyword: string,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/link-or-import?start=${start}&take=${pageLength}&accountName=${keyword}&linked=true`;

export const getAccountListForImportEmbedProcedures = (
  accountId: number,
  start: number,
  pageLength: number,
  keyword: string,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/link-or-import?start=${start}&take=${pageLength}&accountName=${keyword}&includeCurrentAccount=true`;

export const getProcedureNameList = (account: number): string =>
  `${apiBaseUrl}accounts/${account}/procedures/procedure-uri-list`;

export const updateAutoSaveOption = (accountId: number | undefined): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/autosave`;

export const procedureDownload = (
  accountId: number,
  payload: string,
  name?: string,
  singlePdf?: boolean,
): string =>
  singlePdf
    ? `${apiBaseUrl}accounts/${accountId}/procedures/get-as-html?${payload}&procedureNameIfSingleSelection=${name}`
    : `${apiBaseUrl}accounts/${accountId}/procedures/get-as-html?${payload}`;

export const importCustomTable = (
  accountId: string | number,
  lookupId: string | number,
): string =>
  `${apiBaseUrl}accounts/${accountId}/lookups/${lookupId}/record/import`;

export const uploadExternalDocument = (
  accountId: string,
  filepath: string,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/upload/external-files/${filepath}`;

export const getListForFilesImport = ({
  start,
  pageLength,
  accountId,
  searchKey,
}: {
  start: number;
  pageLength: number;
  accountId: number | string;
  searchKey?: string;
}): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/accounts-list-with-exclusion?start=${start}&take=${pageLength}&searchKey=${searchKey}`;

export const importTemplate = (
  accountId: number | string,
  lookupId: string | undefined,
): string =>
  `${apiBaseUrl}accounts/${accountId}/lookups/${lookupId}/template/export`;

export const exportCustomTable = (
  accountId: number | string,
  lookupId: string | undefined,
): string =>
  `${apiBaseUrl}accounts/${accountId}/lookups/${lookupId}/records/export`;

//Advanced Question Search
export const getQuestionSearchList = `${apiBaseUrl}questions/search`;

//Advanced Section Search
export const getSectionSearchList = `${apiBaseUrl}accounts/surveys/section/search`;

//Advanced Detail Search
export const getDetailSearchList = `${apiBaseUrl}questions/advance-search`;

//Advanced Procedure search
export const getProcedureSearchList = `${apiBaseUrl}accounts/procedures/search`;

export const previewExternalFile = (payload: string): string =>
  `${apiBaseUrl}accounts/procedures/get-external-file?filePath=${payload}`;

export const toggleProcedureVisibility = (
  accountId: number,
  visibilityStatus: number,
): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/visibility/${visibilityStatus}`;

export const formStatusToggle = (
  accountId: number,
  formId: number,
  surveyStatus: number,
): string =>
  `${apiBaseUrl}accounts/${accountId}/surveys/${formId}/status?newSurveyStatusId=${surveyStatus}`;

//Twilio
export const twilioPhoneTypes = apiBaseUrl + 'twilio-phone-types';
export const twilioBranchOutGroup = apiBaseUrl + 'twilio-branchout';
export const twilioRoutingSubGroup = apiBaseUrl + 'twilio-workflow';
export const twilioCountryCodes = apiBaseUrl + 'countries';

export const twilioInfoFetch = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/twilio-info`;

export const twilioInfoSave = (accountId: number): string =>
  `${apiBaseUrl}/accounts/${accountId}/update-twilio`;

export const getTelephonyLog = `${apiBaseUrl}accounts/telephony-logs  `;
///////////////////////////////////////////////API REVAMP - Completed
// 3

export const getUserSettings = apiBaseUrl + 'users/settings/account-builder';

export const releaseNotes = `${apiBaseUrl}release-note/2`;

export const externalLinksForAccount = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedure-builder/procedures/v1/getexternallinksforaccount`;

//Procedure Categories
export const getProcedureCategories = `${apiBaseUrl}procedures/get-categories`;

export const updateProcedureCategory = (accountId: number): string =>
  `${apiBaseUrl}accounts/${accountId}/procedures/update-category`;

// To Check choice option have limited access/not
export const checkChoiceWithLimitedAccess = `${apiBaseUrl}accounts/question-options/check`;
